import React from 'react'
import { WidgetContextHolder } from '@typesApp/WidgetContextHolder'
import { WidgetWithConfigurationHOC, WidgetWithConfigurationProps } from './WidgetHOC'

const MyClaims = React.lazy(() => import('@features/my-claims/MyClaims').then(m => ({ default: m.MyClaims })))

type LegacyShoppingAction = {
  ctaLabel: string
  onClick: () => void
}

type MyClaimsWidgetProps = WidgetWithConfigurationProps & {
  shoppingActions: LegacyShoppingAction[]
  onOrderClick: (orderNumber: string) => void
}

export const MyClaimsWidget: React.FC<MyClaimsWidgetProps> = props => {
  const { customerContext, actionModule, environment, widgetContext, shoppingActions, onOrderClick } = props

  // NOTE: map legacy props until existing brands migrate to use widgetContext
  const context = widgetContext ?? getWidgetContextFromLegacyProps(shoppingActions, onOrderClick)

  return (
    <WidgetWithConfigurationHOC
      customerContext={customerContext}
      environment={environment}
      actionModule={actionModule}
      widgetContext={context}
    >
      <MyClaims />
    </WidgetWithConfigurationHOC>
  )
}

const getWidgetContextFromLegacyProps = (
  legacyActions: LegacyShoppingAction[],
  onOrderClick: (orderNumber: string) => void
): WidgetContextHolder => {
  const actions = legacyActions && Array.isArray(legacyActions) ? legacyActions : []
  const shoppingActions = actions.map(action => ({ label: action.ctaLabel, onClick: action.onClick }))

  return {
    myClaims: {
      shoppingActions,
      onOrderClick,
    },
  }
}
